import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/pro-solid-svg-icons/faLock';
import React from 'react';
import style from './address-unlocking.module.css';
import { FormattedMessage, defineMessages } from 'react-intl';
import PropTypes from 'prop-types';
import { noop } from 'ui-components/default-props/noop';
import { Button } from 'ui-components/components/button';
import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';

const messages = defineMessages({
  lockAddress: {
    description: 'Message indicating address is locked',
    defaultMessage: 'Address Locked',
    id: 'ChSZtu',
  },
  lockAddressTooltip: {
    description: 'Tooltip message indicating the address will not reflect address changes made in the market place',
    defaultMessage: 'This address has been modified and will ignore future changes from the marketplace.',
    id: 'S73UxY',
  },
  lockButton: {
    description: 'Button that allows user to unlock address so it can receive updated address from the market place',
    defaultMessage: 'Unlock',
    id: '09PPKx',
  },
});

export const UnlockAddress = ({ onUnlock = noop }) => {
  const unlockAddressComponent = (
    <div className={style['locked-address']}>
      <div className={style['text-warning']}>
        <FontAwesomeIcon className={style['lock-icon']} icon={faLock} />
        <span>
          <FormattedMessage {...messages.lockAddress} />
        </span>
      </div>
      <Button className={style['locked-address-link']} onClick={onUnlock} theme='link'>
        <FormattedMessage {...messages.lockButton} />
      </Button>
    </div>
  );
  return (
    <Tooltip>
      {unlockAddressComponent}
      <TooltipContent>
        <div>
          <FormattedMessage {...messages.lockAddressTooltip} />
        </div>
      </TooltipContent>
    </Tooltip>
  );
};

UnlockAddress.propTypes = {
  onUnlock: PropTypes.func,
};
